<template>
  <v-container id="change-password">
    <v-row>
      <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
        <v-col class="text-center">
          <h1>Atualizar Senha</h1>
        </v-col>
        <v-form lazy-validation @submit.prevent="onSubmit" ref="form">
          <v-text-field
            label="Nome"
            name="nome"
            type="text"
            v-model="payload.nome"
            disabled
          ></v-text-field>

          <v-text-field
            label="Usuário"
            name="login"
            type="text"
            v-model="payload.email"
            disabled
          ></v-text-field>

          <v-text-field
            ref="password"
            id="passwordsadas"
            label="Nova Senha"
            name="myPassword"
            :type="showPassword ? 'text' : fieldTypes.myPassword"
            append-icon="mdi-eye-off"
            v-model="payload.senha"
            :rules="passwordRules"
            @blur="handleType"
            @focus="handleType"
            @click:append="showPassword = !showPassword"
            required
          ></v-text-field>

          <v-text-field
            id="confirm-password"
            label="Confirmação de Senha"
            name="novaSenha"
            :type="showConfirmPassword ? 'text' : fieldTypes.novaSenha"
            append-icon="mdi-eye-off"
            v-model="payload.confirmacaoSenha"
            :rules="confirmPasswordRules"
            required
            @blur="handleType"
            @focus="handleType"
            @click:append="showConfirmPassword = !showConfirmPassword"
          ></v-text-field>

          <div class="mt-5">
            <div
              v-for="(especificacao, index) in especificacaoSenha"
              :key="index"
              :class="errosSenha.includes(especificacao.name) ? 'falta' : ''"
            >
              - {{ especificacao.title }}
            </div>
          </div>
          <v-row>
            <v-col>
              <div class="text-center">
                <v-btn color="primary" type="submit"> Atualizar Senha </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { userAPI } from "./UserAPI";
import Auth from "@/Auth.js";
import {
  regexSenhaQuebrado,
  especificacaoLabels,
} from "@/helpers/senhaEspecificacao";

export default {
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      payload: Auth.getUser(),
      especificacaoSenha: especificacaoLabels,
      errosSenha: [],
      fieldTypes: {},
      regexSenhaQuebrado: regexSenhaQuebrado,
      showConfirmPassword: false,
      showPassword: false,
      passwordRules: [
        (v) => !!v || "O campo nova senha é obrigatório",
        (v) => {
          if (v && !this.regexSenhaQuebrado.totalRegex.test(v)) {
            this.errosSenha = [];
            !this.regexSenhaQuebrado.letraMinuscula.test(v) &&
              this.errosSenha.push("minuscula");
            !this.regexSenhaQuebrado.letraMaiuscula.test(v) &&
              this.errosSenha.push("maiuscula");
            !this.regexSenhaQuebrado.numero.test(v) &&
              this.errosSenha.push("numero");
            !this.regexSenhaQuebrado.especial.test(v) &&
              this.errosSenha.push("especial");
            v.length < 8 && this.errosSenha.push("caracteres");

            return "Senha fraca";
          }
          this.errosSenha = [];
          return true;
        },
      ],
      confirmPasswordRules: [
        (v) => !!v || "O campo confirmação de senha é obrigatório",
        (v) => {
          if (v !== this.payload.senha) {
            return "As senhas devem ser iguais";
          }
          return true;
        },
      ],
      valid: true,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;
      if (type === "blur" && !value) {
        this.fieldTypes[name] = "text";
      } else {
        this.fieldTypes[name] = "password";
      }
    },
    async onSubmit() {
      var isValid = await this.check();
      if (!isValid) return;

      this.setLoading(true);
      userAPI
        .update(this.payload)
        .then((resp) => {
          this.$notification.success("Senha atualizada com sucesso!", {
            timer: 10,
          });
          this.$router.push("/cidade");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar senha!", { timer: 10 });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.falta {
  color: red;
}
</style>
